export default class Fraction
{
    constructor(numerator, denominator)
    {
        this.numerator = 0;
        this.denominator = 0;
        this.decimalValue = 0.0;
        if (numerator) this.numerator = numerator;
        if (denominator) this.denominator = denominator;
    }
}